import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class QuestionCollections extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'QuestionCollections'
  // Define default properties here
  static instanceDefaults () {
    return {
      visibility: 'private',
      isEnabled: false,
      userId: null,
      mediaId: null,
      media: null,
      organizationId: null,
      title: null,
      translations: [],
    }
  }
}
const servicePath = 'question-collections'
const servicePlugin = makeServicePlugin({
  Model: QuestionCollections,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
